import {Minus, Plus} from '@wix/wix-ui-icons-common/on-stage'
import {useEnvironment, useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {IconButton, IconButtonThemes} from 'wix-ui-tpa/cssVars'
import {classes} from './controls.st.css'
import {ControlsProps} from './interfaces'

export const Controls = ({zoomOutDisabled, zoomInDisabled, onZoomIn, onZoomOut}: ControlsProps) => {
  const {isMobile} = useEnvironment()
  const {t} = useTranslation()

  return (
    <div
      className={classNames(classes.controls, {
        [classes.desktopControls]: !isMobile,
        [classes.mobileControls]: isMobile,
      })}
    >
      <IconButton
        aria-label={t('seating_zoomIn')}
        theme={IconButtonThemes.Box}
        className={classes.control}
        disabled={zoomInDisabled}
        onClick={zoomInDisabled ? undefined : onZoomIn}
        icon={<Plus />}
      />
      <IconButton
        aria-label={t('seating_zoomOut')}
        theme={IconButtonThemes.Box}
        className={classes.control}
        disabled={zoomOutDisabled}
        onClick={zoomOutDisabled ? undefined : onZoomOut}
        icon={<Minus />}
      />
    </div>
  )
}
